import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'rt-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.has-font-weight-normal]': 'hasFontWeightNormal',
    '[class.has-font-weight-medium]': 'hasFontWeightMedium',
    '[class.has-color-default]': 'hasColorDefault',
    '[class.has-color-red]': 'hasColorRed',
    '[class.has-required-badge]': 'hasRequiredBadge',
    '[class.has-font-size-large]': 'hasFontSizeLarge',
    '[class.has-description]': '!!description',
  },
  standalone: true,
  imports: [NgIf],
})
export class LabelComponent {
  @Input() public hasFontWeightNormal: boolean = false;
  @Input() public hasFontWeightMedium: boolean = false;
  @Input() public hasColorDefault: boolean = false;
  @Input() public hasColorRed: boolean = false;
  @Input() public hasRequiredBadge: boolean = false;
  @Input() public hasFontSizeLarge: boolean = false;
  @Input() public description: string = '';
  @Input() public clickable: boolean = false;
}
